import { useLang } from "./i18n";

export function LangToggle() {
  const { lang, setLang } = useLang();
  return (
    <button
      onClick={() => setLang(lang === "en" ? "zh" : "en")}
      className="fixed top-5 right-5 px-3 py-1.5 text-sm rounded-full border border-[var(--color-border)] bg-[var(--color-surface)] text-[var(--color-text-muted)] hover:text-[var(--color-text)] hover:border-[var(--color-text-muted)] transition-colors cursor-pointer"
    >
      {lang === "en" ? "中文" : "EN"}
    </button>
  );
}
